"use client";

import React from "react";
import "./Accreditation_Section.css";

const accreditationData = [
  {
    id: 1,
    logo: "/assets/images/home/Accreditation/1685955289-nirf.jpeg",
    title: "Ranked in Top 50",
    description: "Universities by NIRF",
  },
  {
    id: 2,
    logo: "/assets/images/home/Accreditation/NAAC.jpg",
    title: "'A++' Grade",
    description: "Accreditation by NAAC",
  },
  {
    id: 3,
    logo: "/assets/images/home/Accreditation/UGC.webp",
    title: "UGC Recognized",
    description: "Recognized by University Grants Commission",
  },

  {
    id: 4,
    logo: "/assets/images/home/Accreditation/1327093-o.webp",
    title: "AICTE Approved",
    description: "Approved by All India Council for Technical Education",
  },
  {
    id: 5,
    logo: "/assets/images/home/Accreditation/excellence.png",
    title: "40 Years +",
    description: "of excellence in education",
  },
  {
    id: 6,
    logo: "/assets/images/home/Accreditation/alumini.png",
    title: "1,50,000 +",
    description: "strong alumni network across the globe",
  },
];

const Accreditation_Section = () => {
  return (
    <section className="accreditation_section">
      <div className="container">
        {/* Heading */}
        <div className="accreditation_heading">
          {/* <span className="accreditation_badge">TRUSTED & RECOGNIZED</span> */}

          {/* <h2>
            Excellence That <span>Speaks For Itself</span>
          </h2> */}

          <h2>
            <span>TRUSTED & RECOGNIZED BY</span>
          </h2>

          <p>
            leading national bodies and backed by decades of academic
            excellence.
          </p>
        </div>

        {/* Accreditation Cards */}
        <div className="accreditation_grid">
          {accreditationData.map((item, index) => (
            <div
              className="accreditation_card"
              key={item.id}
              style={{ "--card-index": index }}
            >
              {/* Top glow */}
              <div className="accreditation_card_glow"></div>

              {/* Number */}
              <span className="accreditation_number">
                {String(index + 1).padStart(2, "0")}
              </span>

              {/* Logo */}
              <div className="accreditation_logo_box">
                <img src={item.logo} alt={item.title} loading="lazy" />
              </div>

              {/* Content */}
              <div className="accreditation_content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>

              {/* Bottom accent */}
              <div className="accreditation_bottom_line"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accreditation_Section;
